import { chakra, Flex, Text } from "@chakra-ui/react";

export const InfoText = chakra(Flex, {
  baseStyle: {
    color: "text.placeholder",
    fontSize: "12px",
  },
  label: "info-text",
});

export const LabelText = chakra(Text, {
  baseStyle: {
    color: "#E5E5E5",
    fontSize: "14px",
    whiteSpace: "nowrap",
  },
  label: "label-text",
});

export const EllipseText = chakra(Text, {
  baseStyle: {
    display: "block",
    maxWidth: "100%",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
});
